<template>
  <b-modal
    id="modal-alerta-informativo"
    no-close-on-backdrop
    no-close-on-esc
    hide-header
    hide-footer
    centered
    v-model="modalShow"
  >
    <div class="d-flex flex-column align-items-center justify-content-center my-2">
      <feather-icon
        icon="AlertCircleIcon"
        class="text-warning mb-2"
        size="80"
      />
      <div class="text-center">
        <h3>Atenção!</h3>
        <span>{{ infoText }}</span>
      </div>
      <div class="d-flex mt-3">
        <b-button 
          variant="custom-blue" 
          @click="confirmAction"
          :disabled="loading"
          class="mr-2"
        >
          <span v-if="loading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
          Confirmar
        </b-button>
        <b-button 
          variant="outline-danger" 
          class="mr-2" 
          @click="cancelAction"
          :disabled="loading"
        >
          Cancelar
        </b-button>
        
      </div>
    </div>
  </b-modal>
</template>

<script lang="ts">
import Vue from 'vue'
import { BModal, BButton } from 'bootstrap-vue';

export default Vue.extend({
  name: "ModalAlertaInformativo",
  components: {
    BModal, BButton
  },
  props: {
    modalShow: {
      type: Boolean,
      required: true,
      default: false
    },
    infoText: {
      type: String,
      default: 'A idade ou intervalo informado não corresponde ao recomendado para esta dose. Deseja continuar?'
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    confirmAction(modalEvent) {
      modalEvent.preventDefault();
      this.loading = true;
      this.$emit('confirmed', modalEvent);
    },
    cancelAction(modalEvent) {
      modalEvent.preventDefault();
      this.$emit('canceled', modalEvent);
    }
  },
  watch: {
    modalShow() {
      this.loading = false;
    }
  }
})
</script>

<style scoped lang="scss">
.text-warning {
  color: #ffc107 !important;
}
</style>